/**
 * Shared risks section chrome: actions/meta only.
 * Section tabs live once in RisksContent — do not remount them per page.
 */
export default function RisksTopBar({ tabs = null, actions = null, meta = null }) {
  if (!tabs && !actions && !meta) {
    return null;
  }

  const hasLead = Boolean(tabs || meta);

  return (
    <div className="w-full min-w-0">
      <div
        className={
          hasLead
            ? 'grid w-full min-w-0 grid-cols-1 items-start gap-2 lg:grid-cols-[minmax(0,max-content)_minmax(0,1fr)]'
            : 'w-full min-w-0'
        }
      >
        {hasLead ? (
          <div className="inline-flex max-w-full min-w-0 flex-col items-stretch">
            {tabs}
            {meta ? (
              <div className="mt-1 max-w-full truncate text-[11px] tabular-nums text-slate-500 dark:text-slate-400">
                {meta}
              </div>
            ) : null}
          </div>
        ) : null}
        {actions ? (
          <div
            className={
              hasLead
                ? 'flex w-full min-w-0 flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-end sm:justify-end'
                : 'w-full min-w-0'
            }
          >
            {actions}
          </div>
        ) : null}
      </div>
    </div>
  );
}
